import { Tooltip, useMantineTheme, parseThemeColor } from '@mantine/core';

type Props = {
  tooltip: string;
  children: string;
  c?: string;
};

export const TextWithTooltip = ({ tooltip, children, c = 'gray.10' }: Props) => {
  const theme = useMantineTheme();
  const hexColor = parseThemeColor({ color: c, theme }).value;

  return (
    <Tooltip
      variant="light"
      multiline
      inline
      w={210}
      label={tooltip}
      bg="white"
      c={hexColor}
      styles={{
        tooltip: {
          boxShadow: 'var(--mantine-shadow-xl)',
          borderRadius: 8,
        },
      }}
    >
      <span style={{ borderBottom: `1px dotted ${hexColor}` }}>{children}</span>
    </Tooltip>
  );
};
